import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/page/login_img.png'
import _imports_1 from '@/assets/img/page/login_title.png'
import _imports_2 from '@/assets/img/page/login_icon.png'
import _imports_3 from '@/assets/img/mobile/page/login-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-4212774d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "login-main"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "login-img"
}, null, -1))
const _hoisted_3 = { class: "login-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "login-title"
}, null, -1))
const _hoisted_5 = { class: "login" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title df both-side" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, "天眼")
], -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  id: "captcha",
  ref: "captcha"
}
const _hoisted_10 = {
  id: "msg",
  ref: "msg"
}
const _hoisted_11 = {
  class: "df df-around",
  style: {"margin-top":"0.24rem"}
}
const _hoisted_12 = {
  key: 1,
  class: "login-page"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "login-img"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "天眼", -1))
const _hoisted_15 = { class: "login-box" }
const _hoisted_16 = {
  class: "df df-around",
  style: {"margin-top":"0.2rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_LockFilled = _resolveComponent("LockFilled")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (!_ctx.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (_ctx.showbutton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_a_input, {
                    value: _ctx.username,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                    placeholder: "账号",
                    type: "text",
                    allowClear: true,
                    size: "large"
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_component_UserOutlined)
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _createVNode(_component_a_input, {
                    value: _ctx.password,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                    placeholder: "密码",
                    type: "password",
                    allowClear: true,
                    size: "large"
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_component_LockFilled)
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.showbutton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, null, 512),
                  _createElementVNode("div", _hoisted_10, null, 512)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showbutton)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 2,
                  type: "primary",
                  size: "mini",
                  onClick: _ctx.login,
                  class: "login-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 登录 ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_a_checkbox, {
                checked: _ctx.rpassword,
                "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rpassword) = $event)),
                onChange: _ctx.rpasswordStatusChange
              }, {
                default: _withCtx(() => [
                  _createTextVNode("记住密码")
                ]),
                _: 1
              }, 8, ["checked", "onChange"]),
              _createVNode(_component_a_checkbox, {
                checked: _ctx.automaticlogon,
                "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.automaticlogon) = $event)),
                disabled: !_ctx.rpassword
              }, {
                default: _withCtx(() => [
                  _createTextVNode("自动登录")
                ]),
                _: 1
              }, 8, ["checked", "disabled"])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_a_input, {
            class: "form-input input-space",
            value: _ctx.username,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.username) = $event)),
            placeholder: "请输入账号",
            allowClear: ""
          }, null, 8, ["value"]),
          _createVNode(_component_a_input, {
            class: "form-input",
            value: _ctx.password,
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.password) = $event)),
            placeholder: "请输入密码",
            type: "password",
            allowClear: ""
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_a_checkbox, {
              checked: _ctx.rpassword,
              "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rpassword) = $event)),
              onChange: _ctx.rpasswordStatusChange
            }, {
              default: _withCtx(() => [
                _createTextVNode("记住密码")
              ]),
              _: 1
            }, 8, ["checked", "onChange"]),
            _createVNode(_component_a_checkbox, {
              checked: _ctx.automaticlogon,
              "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.automaticlogon) = $event)),
              disabled: !_ctx.rpassword
            }, {
              default: _withCtx(() => [
                _createTextVNode("自动登录")
              ]),
              _: 1
            }, 8, ["checked", "disabled"])
          ]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.tologin,
            class: "login-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("登录")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]))
}